import {buttonColors} from "../../../Pickers/InputTheme";
import {i18n} from "../../../../Utils/i18n/i18n";
import {Button} from "../../../Form/Button/Button";
import React, {useContext} from "react";
import {Modal} from "../../../Smart/Modal/Modal";
import {CopyText} from "../../../../Utils/CopyText/CopyText";
import {SA_getPartnerCreds} from "../../../../Services/SA_api";
import {GridReactContext} from "../../../../Utils/DataGridWrapper/GridContext";
import {UserReactContext} from "../../../../contexts/UserContext";
import {get} from "lodash";
import './SuperAdminGenerateClientCreds.scss'

/**
 * Button and modal that generate new client credentials for a partner
 * @param {object} params - The component props
 * @param {string} params.partnerId - The partner ID
 * @returns {JSX.Element} The button and its modal
 */
export const SuperAdminGenerateClientCreds = ({partnerId}) => {
    const [generateAPIKeyModalOpen, setGenerateAPIKeyModalOpen] = React.useState(false)
    const [clientCreds, setClientCreds] = React.useState(null)
    const gridContext = useContext(GridReactContext)
    const userContext = useContext(UserReactContext)
    const onOpenModal = () => {
        setGenerateAPIKeyModalOpen(true)
    }
    const closeEditModal = () => {
        setGenerateAPIKeyModalOpen(false)
        // The new secret shows only in this modal, so refresh only after it closes
        gridContext.triggerTableRefresh()
        userContext.checkExpiringPartnerSecrets()
    }

    const getPartnerCreds = async () => {
        const clientCreds = await SA_getPartnerCreds({partnerId: partnerId})
        setClientCreds(clientCreds)
        onOpenModal()
    }

    return <div className="SuperAdminGenerateClientCreds">
        <Button color={buttonColors.GREY}
                size="small"
                text={i18n.translate('superAdmin.generateClientCreds.generateClientCreds')}
                onClick={getPartnerCreds}/>

        {generateAPIKeyModalOpen ? <Modal
            open={generateAPIKeyModalOpen}
            onClose={closeEditModal}>
            <div className="SuperAdminEditFFModal modalWrapper">
                <div className="modalTitle">
                    <div>{i18n.translate('superAdmin.generateClientCreds.modalTitle')}</div>
                </div>
                <div className="modalContent">
                   <div className="tokenWrappers">
                       {get(clientCreds, 'clientId') ? <div className="SuperAdminTokenCopy">
                           <span>{i18n.translate('superAdmin.generateClientCreds.clientId')}</span><CopyText text={get(clientCreds, 'clientId')}/>
                       </div> : ""}
                       {get(clientCreds, 'clientSecret') ? <div className="SuperAdminTokenCopy">
                           <span>{i18n.translate('superAdmin.generateClientCreds.clientSecret')}</span><CopyText text={get(clientCreds, 'clientSecret')}/>
                       </div> : ""}
                   </div>
                </div>
                <div className="modalFooter">
                    <Button
                        color={buttonColors.GREY}
                        onClick={closeEditModal}
                        text={i18n.translate('general.close')}
                    />
                </div>
            </div>
        </Modal> : ''}
    </div>
}